import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Keys } from '@holmescorp/common';
import { createNlsMiddleware, rollupStatus, userstate } from '@holmescorp/lcc-state';
import { logUser } from '@holmescorp/logger';
import css from '../css/topicpage.m.css';
const nls = createNlsMiddleware('ditabook');
const factory = create({ theme, nls, userstate });
export const GotIt = factory(({ middleware: { theme, nls, userstate } }) => {
    const themeCss = theme.classes(css);
    const { get, path } = userstate;
    const status = get(path('status'));
    const location = get(path('location'));
    const change_state = () => {
        const topic = location.split('/').reverse()[0];
        const data = { ...status[topic].data };
        const value = data.complete === 1 ? 0 : 1;
        data.complete = value;
        logUser.info(`${location} flagged as ${value === 0 ? 'unread' : 'read'}`);
        rollupStatus(topic, data);
    };
    const { isPlaceholder, messages: { gotit = '[ditabook] gotit' } } = nls();
    if (isPlaceholder) {
        return null;
    }
    const topic = location.split('/').reverse()[0];
    const { complete } = status[topic].data;
    const aria = { checked: complete === 1 ? 'true' : 'false' };
    return v('div', { classes: [themeCss.gotitBlock] }, [
        v('div', {
            tabIndex: 0,
            role: 'checkbox',
            ...formatAriaProperties(aria),
            classes: [themeCss.gotit],
            onclick: (event) => {
                event.stopPropagation();
                change_state();
            },
            onkeydown: (event) => {
                switch (event.key) {
                    case Keys.Enter:
                    case Keys.Space:
                    case Keys.Spacebar:
                        event.preventDefault();
                        change_state();
                }
            }
        }, [
            v('span', { id: 'gotit' }, [`${gotit} `]),
            v('i', {
                classes: [complete === 1 ? 'fa' : 'far', 'fa-lg', complete === 1 ? 'fa-check-square' : 'fa-square'],
                'aria-hidden': 'true'
            })
        ])
    ]);
});
